import { cn } from "../lib/utils";
import logoLight from "../assets/ryddion-logo.svg";
import logoDark from "../assets/ryddion-logo-dark.svg";

/**
 * The Ryddion wordmark in the variant the theme needs (CD-002). The letters
 * are black in the brand file and vanish on the dark background; the dark
 * variant lightens only them and keeps the orange as it is. Both images are
 * in the DOM and CSS picks one, so there is no flash on a theme switch.
 */
export function BrandLogo({ className }: { className?: string }): JSX.Element {
  return (
    <>
      <img src={logoLight} alt="Ryddion" className={cn("w-auto dark:hidden", className)} />
      <img src={logoDark} alt="Ryddion" className={cn("hidden w-auto dark:block", className)} />
    </>
  );
}
